import { render, staticRenderFns } from "./FAQTable.vue?vue&type=template&id=381d0aaf"
import script from "./FAQTable.vue?vue&type=script&lang=js"
export * from "./FAQTable.vue?vue&type=script&lang=js"
import style0 from "./FAQTable.vue?vue&type=style&index=0&id=381d0aaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports